import Breadcrumbs from "@mui/material/Breadcrumbs";
import { ROUTES } from "constants/routes";
import { generatePath } from "react-router-dom";
import TablePagination from "components/table-pagination";
import Link from "components/link";
import { useNavigate } from "hooks/use-navigate";
import { useDictionary } from "hooks/use-dictionary";
import Layout from "components/layout";
import { Container } from "@mui/material";
import FiltersBar from "./components/filters-bar";
import FiltersAlert from "./components/filters-alerts";
import EmptyState from "components/empty-state";
import { useEffect } from "react";
import { useUrlParams } from "hooks/use-url-params";
import { SubmitOnEnterKeyPress } from "components/submit-on-enter-key-press";
import { usePublicPrograms } from "hooks/api/use-public-programs";
import ProgramCard from "components/program-card";
import { PublicProgramFilters } from "types/program";

const ProgramsPage = () => {
  const navigate = useNavigate();
  const programsData = usePublicPrograms(12);
  const { items: programs, filters, setFilters, tableTop, ...pagination } = programsData;
  const dict = useDictionary();
  const { constructUrlParams, filters: urlFilters } = useUrlParams();

  useEffect(() => {
    if (Object.keys(urlFilters).length === 0) return;
    setFilters(urlFilters);
  }, [urlFilters]);

  useEffect(() => {
    if (pagination.page > pagination.pages) {
      pagination.onPage(1);
    }
  }, [pagination]);

  return (
    <Layout>
      <Container>
        <div className="space-y-6 py-10">
          <Breadcrumbs>
            <Link to={ROUTES.home}>{dict.common.breadcrumbsRoot}</Link>
            <div>{dict.programs.title}</div>
          </Breadcrumbs>
          <div className="flex justify-between items-center">
            <div className="text-2xl font-bold">{dict.programs.title}</div>
          </div>
          <SubmitOnEnterKeyPress>
            <FiltersBar onSubmit={setFilters} onClear={() => setFilters({})} />
          </SubmitOnEnterKeyPress>
          <FiltersAlert filters={filters as PublicProgramFilters} />
          <div>
            {tableTop}
            <div className="grid xl:grid-cols-3 sm:grid-cols-2 gap-5">
              {programs.map((program) => (
                <ProgramCard
                  program={program}
                  className=" hover:bg-theme-gray100 cursor-pointer"
                  onClick={() =>
                    navigate(ROUTES.home + generatePath(ROUTES.programView, { id: program.id }) + constructUrlParams())
                  }
                />
              ))}
              {programs.length === 0 && (
                <div className="flex flex-col items-center bg-white border py-2 xl:col-span-3 sm:col-span-2">
                  <EmptyState
                    title={dict.common.programEmptyState.title}
                    text={dict.common.programEmptyState.description}
                  />
                </div>
              )}
            </div>
          </div>
          <TablePagination className="bg-white rounded-b border px-5 py-2" {...pagination} rowsPerPageOptions={[12]} />
        </div>
      </Container>
    </Layout>
  );
};

export default ProgramsPage;
